import React, { useEffect, useState } from "react";
import { Spin, Modal, Tooltip } from "antd";
import SaveIcon from "../../assets/images/choose-setting/save__icon.svg";
import ResetIcon from "../../assets/images/choose-setting/reset__icon.svg";
import selectYourDiamondService from "../../services/select-your-diamond.service";
import { useSelector, useDispatch } from "react-redux";
import {
  handleResetMinedPage,
  handleResetLabPage,
  handleResetFancyPage,
  handleResetRequestPage,
  handleSetSaveSearchMinedTab,
  handleSetSwitchFilter,
  handleSetSaveSearchLabTab,
  handleSetSwitchLabFilter,
  handleSetSaveSearchFancyTab,
  handleSetSwitchFancyFilter,
  handleSetDiamondActiveTab,
  handleComaparePageIds,
  handleResetMinedToggle,
} from "../../actions/selectYourDiamond/selectYourDiamond";
import { NotificationManager } from "react-notifications";
import colorPanelService from "../../services/color-panel.service";
import { useNavigate, useLocation } from "react-router-dom";
import { SET_REFRESHLABTAB } from "../../actions/selectYourDiamond/types";
import UnionIcon from "../../assets/images/icons/Union_5.svg";
import { setGlobalFontFamily } from "../../actions/PreviewColor/previewColor";
import { useTranslation } from "react-i18next";

const SelectYourDiamond = ({}) => {
  const { t } = useTranslation();
  const search = useLocation().search;
  const paramdealerId = new URLSearchParams(search).get("DealerLink");
  const isChange = new URLSearchParams(search).get("isChange");
  const setParamValues = new URLSearchParams(search).get("setParamValues");
  const paramsettingShape = new URLSearchParams(search).get("settingShape");
  const paramcenterStoneMinimumCarat = new URLSearchParams(search).get(
    "centerStoneMinimumCarat"
  );
  const paramcenterStoneMaximumCarat = new URLSearchParams(search).get(
    "centerStoneMaximumCarat"
  );
  const paramSettingId = new URLSearchParams(search).get("settingId");
  const paramSettingNumber = new URLSearchParams(search).get("settingNumber");
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Mined");
  const [navigationData, setNavigationData] = useState([]);
  const [orderNumbers, setOrderNumbers] = useState([]);
  const [isAdvance, setIsAdvance] = useState(false);
  const [noDiamondToCompare, setNoDiamondToCompare] = useState(false);

  const pageDetails = useSelector((state) => state.selectYourDiamondReducer);
  const CompareIds = useSelector(
    (state) => state.selectYourDiamondReducer.compareIds.ids
  );
  const dispatch = useDispatch();
  const tooltipContent = {
    Mined: t(
      "Formed over billions of years, natural diamonds are mined from the earth. Diamonds are the hardest mineral on earth, which makes them an ideal material for daily wear over a lifetime. Our natural diamonds are conflict-free and GIA certified."
    ),
    Lab: t(
      "Lab-grown diamonds are created in a lab by replicating the high heat and high pressure environment that causes a natural diamond to form. They are compositionally identical to natural mined diamonds (hardness, density, light refraction, etc), and the two look exactly the same. A lab-grown diamond is an attractive alternative for those seeking a product with less environmental footprint."
    ),
  };

  const handleTabChange = (val) => {
    if (val === "Compare" && (!CompareIds || CompareIds.length === 0)) {
      setNoDiamondToCompare(true);
      return; // Prevent changing the active tab
    }
    setActiveTab(val);
    if (setParamValues == "True") {
      if (val == "Mined") {
        navigate(
          "/Mined" +
            `?DealerLink=${paramdealerId}&showHeader=True&setParamValues=True&settingShape=${paramsettingShape}&centerStoneMinimumCarat=${paramcenterStoneMinimumCarat}&centerStoneMaximumCarat=${paramcenterStoneMaximumCarat}&headerTab=selectYourDiamond&settingViewEdit=True&settingId=${paramSettingId}&settingNumber=${paramSettingNumber}&advancedSearch=${isAdvance}`
        );
      } else if (val == "Lab") {
        navigate(
          "/Lab" +
            `?DealerLink=${paramdealerId}&showHeader=True&setParamValues=True&settingShape=${paramsettingShape}&centerStoneMinimumCarat=${paramcenterStoneMinimumCarat}&centerStoneMaximumCarat=${paramcenterStoneMaximumCarat}&headerTab=selectYourDiamond&settingViewEdit=True&settingId=${paramSettingId}&settingNumber=${paramSettingNumber}&advancedSearch=${isAdvance}`
        );
      } else if (val == "Request") {
        navigate(
          "/Request" +
            `?DealerLink=${paramdealerId}&showHeader=True&setParamValues=True&settingShape=${paramsettingShape}&centerStoneMinimumCarat=${paramcenterStoneMinimumCarat}&centerStoneMaximumCarat=${paramcenterStoneMaximumCarat}&headerTab=selectYourDiamond&settingViewEdit=True&settingId=${paramSettingId}&settingNumber=${paramSettingNumber}&advancedSearch=${isAdvance}`
        );
      } else if (val == "Compare") {
        let compareIds = CompareIds && CompareIds.toString();
        let pageName = "";
        if (window.location.href.indexOf("Mined") > -1) {
          pageName = "Mined";
        } else {
          pageName = "Lab";
        }
        navigate(
          "/Compare" +
            `?DealerLink=${paramdealerId}&CompareIds=${compareIds}&pageName=${pageName}&showHeader=True&setParamValues=True&settingShape=${paramsettingShape}&centerStoneMinimumCarat=${paramcenterStoneMinimumCarat}&centerStoneMaximumCarat=${paramcenterStoneMaximumCarat}&headerTab=selectYourDiamond&settingViewEdit=True&settingId=${paramSettingId}&settingNumber=${paramSettingNumber}`
        );
      } else {
        navigate(
          "/Mined" +
            `?DealerLink=${paramdealerId}&showHeader=True&setParamValues=True&settingShape=${paramsettingShape}&centerStoneMinimumCarat=${paramcenterStoneMinimumCarat}&centerStoneMaximumCarat=${paramcenterStoneMaximumCarat}&headerTab=selectYourDiamond&settingViewEdit=True&settingId=${paramSettingId}&settingNumber=${paramSettingNumber}&advancedSearch=${isAdvance}`
        );
      }
    } else {
      if (val == "Mined") {
        navigate(
          "/Mined" +
            `?DealerLink=${paramdealerId}&showHeader=True&headerTab=selectYourDiamond&advancedSearch=${isAdvance}`
        );
      } else if (val == "Lab") {
        navigate(
          "/Lab" +
            `?DealerLink=${paramdealerId}&showHeader=True&headerTab=selectYourDiamond&advancedSearch=${isAdvance}`
        );
      } else if (val == "Request") {
        navigate(
          "/Request" +
            `?DealerLink=${paramdealerId}&showHeader=True&headerTab=selectYourDiamond&advancedSearch=${isAdvance}`
        );
      } else if (val == "Compare") {
        let compareIds = CompareIds && CompareIds.toString();
        let pageName = "";
        if (window.location.href.indexOf("Mined") > -1) {
          pageName = "Mined";
        } else {
          pageName = "Lab";
        }
        navigate(
          "/Compare" +
            `?DealerLink=${paramdealerId}&CompareIds=${compareIds}&pageName=${pageName}&showHeader=True&headerTab=selectYourDiamond`
        );
      } else {
        navigate(
          "/Mined" +
            `?DealerLink=${paramdealerId}&showHeader=True&headerTab=selectYourDiamond&advancedSearch=${isAdvance}`
        );
      }
    }
    dispatch(handleSetDiamondActiveTab(val));

    if (val !== "Compare") {
      dispatch(handleComaparePageIds(""));
    }
  };

  const handleSaveSearchForPage = () => {
    if (activeTab == "Mined") {
      dispatch(handleSetSaveSearchMinedTab(true));
      dispatch(handleResetMinedPage(false));
      dispatch(handleSetSwitchFilter());
    }
    if (activeTab == "Lab") {
      dispatch(handleSetSaveSearchLabTab(true));
      dispatch(handleResetLabPage(false));
      dispatch(handleSetSwitchLabFilter());
    }
    if (activeTab == "FancyColor") {
      dispatch(handleSetSaveSearchFancyTab(true));
      dispatch(handleResetFancyPage(false));
      dispatch(handleSetSwitchFancyFilter());
    }
    NotificationManager.success(t("Search Saved Successfully."));
  };

  useEffect(() => {
    if (paramdealerId) {
      handleGetNavigationData(paramdealerId);
    }
    dispatch(handleComaparePageIds(""));
  }, []);

  useEffect(() => {
    if (pageDetails) {
      if (pageDetails.activeDiamondTab) {
        setActiveTab(pageDetails.activeDiamondTab);
      }
    }
  }, [pageDetails.activeDiamondTab]);

  const [selectYourDiamondLoading, setSelectYourDiamondLoading] =
    useState(false);
  const handleGetNavigationData = async (id) => {
    let inputData = {
      dealerId: id.toString(),
    };
    setSelectYourDiamondLoading(true);
    try {
      await selectYourDiamondService
        .GetRingBuilderOpeningPage(inputData)
        .then((response) => {
          let responseData = response.data.responseData;
          if (responseData) {
            let navigationArray = [];
            if (responseData.advancedSearchData) {
              if (responseData.advancedSearchData[0].setting == "True") {
                setIsAdvance(true);
              }
            }
            if (responseData.labData) {
              navigationArray.push(responseData.labData[0]);
            }
            if (responseData.minedData) {
              navigationArray.push(responseData.minedData[0]);
            }
            if (responseData.requestDiamondData) {
              navigationArray.push(responseData.requestDiamondData[0]);
            }
            if (responseData.compareDiamondData) {
              navigationArray.push(responseData.compareDiamondData[0]);
              localStorage.setItem(
                "compareData",
                JSON.stringify(responseData.compareDiamondData[0])
              );
            }

            let newArray = [];
            for (let i = 0; i < navigationArray.length + 1; i++) {
              newArray.push((i + 1).toString());
            }
            setOrderNumbers(newArray);
            setSelectYourDiamondLoading(false);
            let newminArr = navigationArray
              .filter((x) => x.setting == "True")
              .map((x) => {
                return x.order;
              });
            let val = Math.min(...newminArr);
            let newActiveTab = navigationArray
              .filter((item) => {
                return item.setting == "True" && item.order == val.toString();
              })[0]
              .name.toString();
            setNavigationData(navigationArray);
            if (setParamValues == "True") {
              navigate(
                "/Mined" +
                  `?DealerLink=${paramdealerId}&showHeader=True&setParamValues=True&settingShape=${paramsettingShape}&centerStoneMinimumCarat=${paramcenterStoneMinimumCarat}&centerStoneMaximumCarat=${paramcenterStoneMaximumCarat}&headerTab=selectYourDiamond&settingViewEdit=True&settingId=${paramSettingId}&settingNumber=${paramSettingNumber}&advancedSearch=${
                    responseData.advancedSearchData[0].setting == "True"
                      ? true
                      : false
                  }`
              );
              setActiveTab("Mined");
            } else {
              if (isChange == "True") {
                if (newActiveTab == "Mined") {
                  navigate(
                    "/Mined" +
                      `?DealerLink=${paramdealerId}&showHeader=True&headerTab=selectYourDiamond&advancedSearch=${
                        responseData.advancedSearchData[0].setting == "True"
                          ? true
                          : false
                      }`
                  );
                  setActiveTab("Mined");
                } else if (newActiveTab == "Lab") {
                  navigate(
                    "/Lab" +
                      `?DealerLink=${paramdealerId}&showHeader=True&headerTab=selectYourDiamond&advancedSearch=${
                        responseData.advancedSearchData[0].setting == "True"
                          ? true
                          : false
                      }`
                  );
                  setActiveTab("Lab");
                } else if (newActiveTab == "Request") {
                  navigate(
                    "/Request" +
                      `?DealerLink=${paramdealerId}&showHeader=True&headerTab=selectYourDiamond&advancedSearch=${
                        responseData.advancedSearchData[0].setting == "True"
                          ? true
                          : false
                      }`
                  );
                  setActiveTab("Request");
                } else if (newActiveTab == "Compare") {
                  navigate(
                    "/Compare" +
                      `?DealerLink=${paramdealerId}&showHeader=True&headerTab=selectYourDiamond`
                  );
                  setActiveTab("Compare");
                } else {
                  navigate(
                    "/Mined" +
                      `?DealerLink=${paramdealerId}&showHeader=True&headerTab=selectYourDiamond&advancedSearch=${
                        responseData?.advancedSearchData?.[0]?.setting == "True"
                          ? true
                          : false
                      }`
                  );
                  setActiveTab("Mined");
                }
                setActiveTab(newActiveTab);
                dispatch(handleSetDiamondActiveTab(newActiveTab));
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  function getTextStyle(name) {
    if (activeTab == name) {
      return {
        color: "#fff",
        background: `${varColorObj.columnHeaderAccentColor}`,
      };
    }
  }

  const handleResetForPage = () => {
    if (activeTab == "Mined") {
      dispatch(handleResetMinedToggle());
      dispatch(handleResetMinedPage(true));
      dispatch(handleSetSaveSearchMinedTab(false));
    }
    if (activeTab == "Lab") {
      dispatch({ type: SET_REFRESHLABTAB });
      dispatch(handleResetLabPage(true));
      dispatch(handleSetSaveSearchLabTab(false));
    }
    if (activeTab == "FancyColor") {
      dispatch(handleResetFancyPage(true));
      dispatch(handleSetSaveSearchFancyTab(false));
    }
    if (activeTab == "Request") {
      dispatch(handleResetRequestPage());
    }
    NotificationManager.success(t("Search Reset Successfully."));
  };

  /* Color Individually Start */
  const previewcolor = useSelector((state) => state.previewColorReducer);
  const [varColorObj, setVarColorObj] = useState({
    callToActionColor: "",
    hoverColor: "",
    columnHeaderAccentColor: "",
    linkColor: "",
  });
  useEffect(() => {
    if (paramdealerId) {
      handleGetColorsData(paramdealerId);
    }
  }, [previewcolor.toogle]);

  const handleCloseNoDiamondModal = () => {
    setNoDiamondToCompare(false);
  };

  const handleGetColorsData = (id) => {
    let inputData = {
      dealerID: Number(id),
      moduleName: "RingBuilder",
      hoverEffect: "",
      columnHeaderAccent: "",
      linkColor: "",
      actionButton: "",
    };

    colorPanelService
      .GetHoverEffect(inputData)
      .then((response) => {
        let msg = response.data.message;
        let initialColorObj =
          response.data.responseData.initialHoverEffectList[0];
        let newColorObj =
          response.data.responseData.ringBuilder_HoverEffect_List[0];
        let colorObj = {
          hoverEffect: "",
          columnHeaderAccent: "",
          linkColor: "",
          actionButton: "",
        };
        if (msg == "Success") {
          if (initialColorObj) {
            let tempobj = colorObj;
            tempobj.hoverEffect = newColorObj
              ? newColorObj.hoverEffect == ""
                ? initialColorObj.hoverEffect
                : newColorObj.hoverEffect
              : initialColorObj.hoverEffect;
            tempobj.columnHeaderAccent = newColorObj
              ? newColorObj.columnHeaderAccent == ""
                ? initialColorObj.columnHeaderAccent
                : newColorObj.columnHeaderAccent
              : initialColorObj.columnHeaderAccent;
            tempobj.linkColor = newColorObj
              ? newColorObj.linkColor == ""
                ? initialColorObj.linkColor
                : newColorObj.linkColor
              : initialColorObj.linkColor;
            tempobj.actionButton = newColorObj
              ? newColorObj.actionButton == ""
                ? initialColorObj.actionButton
                : newColorObj.actionButton
              : initialColorObj.actionButton;
            dispatch(setGlobalFontFamily(newColorObj.chooseFont));
            if (tempobj) {
              setVarColorObj({
                ...varColorObj,
                callToActionColor: tempobj.actionButton,
                hoverColor: tempobj.hoverEffect,
                columnHeaderAccentColor: tempobj.columnHeaderAccent,
                linkColor: tempobj.linkColor,
              });
            } else {
              setVarColorObj({
                ...varColorObj,
                callToActionColor: initialColorObj.actionButton,
                hoverColor: initialColorObj.hoverEffect,
                columnHeaderAccentColor: initialColorObj.columnHeaderAccent,
                linkColor: initialColorObj.linkColor,
              });
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <React.Fragment>
      <Spin spinning={selectYourDiamondLoading}>
        <div className="allprod_section jwlsrch__section app__preview choose__setting">
          <div className="row">
            <div className="col-md-12">
              <div className="prodetail__section">
                <div className="col-md-12">
                  <div className="prod__maindiv app__preview p-0 border-0">
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <div className="prodesc__div">
                          <div className="tright__btns">
                            {activeTab != "Compare"
                              ? activeTab !== "Request" && (
                                  <>
                                    <p onClick={handleSaveSearchForPage}>
                                      <img src={SaveIcon} alt="Save Icon" />
                                      <span>{t("Save Search")}</span>
                                    </p>
                                    <p onClick={handleResetForPage}>
                                      <img src={ResetIcon} alt="Reset Icon" />
                                      <span>{t("Reset")}</span>
                                    </p>
                                  </>
                                )
                              : null}
                          </div>

                          <div className="custom__tab">
                            <ul>
                              {orderNumbers.map((order) => {
                                return navigationData.map((tab, index) => {
                                  const isTooltipRequired = index < 2;
                                  const tooltipText = isTooltipRequired
                                    ? tooltipContent[tab.name] || ""
                                    : "";
                                  return (
                                    tab.setting == "True" &&
                                    order == tab.order && (
                                      <li
                                        style={getTextStyle(tab.name)}
                                        onClick={() =>
                                          handleTabChange(tab.name)
                                        }
                                      >
                                        <span>
                                          {tab.name == "Compare"
                                            ? activeTab == "Compare"
                                              ? t("Compare")
                                              : `${t("Compare")} (${
                                                  CompareIds
                                                    ? CompareIds.length
                                                    : 0
                                                })`
                                            : tab.name == "Fancy Colored"
                                            ? t(
                                                tab.name.split(/(?=[A-Z])/)[0]
                                              ) +
                                              " " +
                                              t(tab.name.split(/(?=[A-Z])/)[1])
                                            : t(tab.name)}
                                        </span>
                                        {isTooltipRequired && (
                                          <Tooltip
                                            title={tooltipText}
                                            placement="rightTop"
                                          >
                                            <img
                                              src={UnionIcon}
                                              alt=""
                                              style={{
                                                marginLeft: "8px",
                                                cursor: "pointer",
                                                width: "14px",
                                                backgroundColor: "white",
                                                borderRadius: "50%",
                                              }}
                                            />
                                          </Tooltip>
                                        )}
                                      </li>
                                    )
                                  );
                                });
                              })}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Spin>
      <Modal
        title={t("Alert")}
        className="datamapping__modal"
        width={400}
        centered
        visible={noDiamondToCompare}
        onCancel={handleCloseNoDiamondModal}
        maskClosable={false}
        okText={t("Ok")}
        onOk={handleCloseNoDiamondModal}
        cancelText={t("Cancel")}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <div className="form__fields row border-0 p-0">
          <div className="col-lg-12 text-center">
            <p>{t("Kindly Select a diamond to Compare")}</p>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default SelectYourDiamond;
